import { useEffect, useRef, useState } from "react";
import { LandingNav } from "@/components/landing/LandingNav";
import { DealBanner } from "@/components/landing/DealBanner";
import { Hero } from "@/components/landing/Hero";
import { TrustBand } from "@/components/landing/TrustBand";
import { FeaturesBento } from "@/components/landing/FeaturesBento";
import { SocialProof } from "@/components/landing/SocialProof";
import { PricingPreview } from "@/components/landing/PricingPreview";
import { LandingFooter } from "@/components/landing/LandingFooter";
import { ClaimPopup } from "@/components/landing/ClaimPopup";
import { fetchActiveDeal, formatCountdown } from "@/lib/promos";

export default function Landing() {
    const [deal, setDeal] = useState(null);
    const [secs, setSecs] = useState(0);
    const [popup, setPopup] = useState(false);
    const deadlineRef = useRef(0);

    const load = async () => {
        try {
            const d = await fetchActiveDeal();
            setDeal(d.deal);
            deadlineRef.current = Date.now() + (d.seconds_remaining || 0) * 1000;
            setSecs(d.seconds_remaining || 0);
        } catch { /* deal banner simply hides */ }
    };

    useEffect(() => { load(); }, []);

    useEffect(() => {
        const t = setInterval(() => {
            const remaining = Math.round((deadlineRef.current - Date.now()) / 1000);
            if (remaining <= 0) load();   // rotation hit — fetch the next deal
            else setSecs(remaining);
        }, 1000);
        return () => clearInterval(t);
    }, []);

    useEffect(() => {
        const prev = document.title;
        document.title = "WhiteWater AI — Elite Real-Time FPS Gameplay Coach";
        return () => { document.title = prev; };
    }, []);

    // Exit-intent: when the cursor leaves the top of the viewport (about to close/leave),
    // surface the daily deal once per session to recover the visitor.
    useEffect(() => {
        const onLeave = (e) => {
            if (e.clientY <= 0 && !e.relatedTarget && !sessionStorage.getItem("ww_exit_intent")) {
                sessionStorage.setItem("ww_exit_intent", "1");
                setPopup(true);
            }
        };
        document.addEventListener("mouseout", onLeave);
        return () => document.removeEventListener("mouseout", onLeave);
    }, []);

    return (
        <div className="min-h-screen bg-obsidian text-white selection:bg-volt/30" data-testid="landing-page">
            <LandingNav />
            <DealBanner deal={deal} countdown={formatCountdown(secs)} onClaim={() => setPopup(true)} />
            <Hero deal={deal} onClaim={() => setPopup(true)} />
            <SocialProof />
            <TrustBand />
            <FeaturesBento />
            <PricingPreview deal={deal} />
            <LandingFooter />
            <ClaimPopup open={popup} onOpenChange={setPopup} deal={deal} />
        </div>
    );
}
